import {
  IAddSchoolPayload,
  IScheduleRenewalPayload,
  IEditSubscriptionPayload,
} from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getSchoolList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/school${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getSchoolSummary = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/school/summary${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getTeacherList = async (payload?: Record<string, unknown>) => {
  return serviceHelper(http.post(`/admin/teacher/list`, payload), false);
};

export const getTeacherSummary = async (params?: Record<string, unknown>) => {
  return serviceHelper(http.get(`/admin/teacher/summary`, { params }), false);
};

export const getTeacherLessonList = async (
  id: string,
  payload?: Record<string, unknown>
) => {
  return serviceHelper(
    http.post(`/admin/teacher/${id}/lesson`, payload),
    false
  );
};

export const getTeacherLessonSummary = async (
  id: string,
  params?: Record<string, unknown>
) => {
  return serviceHelper(
    http.get(`/admin/teacher/${id}/lesson/summary`, { params }),
    false
  );
};

export const getTeacherDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/teacher/${id}`), false);
};

export const getLessonDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/teacher/lesson/${id}`), false);
};

export const deleteGame = async (lessonId: string, gameId: string) => {
  return serviceHelper(
    http.delete(`/admin/teacher/lesson/${lessonId}/game/${gameId}`),
    true
  );
};

export const addSchoolData = async (payload: IAddSchoolPayload) => {
  return serviceHelper(http.post('/admin/school', payload), false);
};

export const scheduleSchoolRenewal = async (
  payload: IScheduleRenewalPayload
) => {
  return serviceHelper(
    http.post('/admin/school/renew-subscription', payload),
    false
  );
};

export const editSchoolSubscription = async (
  payload: IEditSubscriptionPayload
) => {
  return serviceHelper(
    http.patch('/admin/school/subscription', payload),
    false
  );
};

export const getSchoolDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/school/${id}`), false);
};

export const getSchoolSubscription = async (school_id: string) => {
  return serviceHelper(
    http.get(`/admin/school/subscription/${school_id}`),
    false
  );
};

export const updateSchoolImage = async (data: FormData) => {
  return serviceHelper(
    http.post(`/upload/school/image`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    false
  );
};

export const getparentList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/parent${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getParentSummary = async (params?: Record<string, unknown>) => {
  return serviceHelper(http.get(`/admin/parent/summary`, { params }), false);
};

export const getParentDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/parent/${id}`), false);
};

export const getChildDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/child/${id}`), false);
};

export const getSchoolStudentList = async (
  school_id: string,
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/school/${school_id}/students${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getSchoolStudentSummary = async (
  params?: Record<string, unknown>
) => {
  return serviceHelper(
    http.get(`/admin/school/student/summary`, { params }),
    false
  );
};
